import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import Grid from '@mui/material/Grid';

import ErrorFallback from 'components/base/ErrorFallback';
import { useAuth } from 'hooks/useAuth';
import LoaderSpinner from 'components/elements/LoaderSpinner';
import { ROUTE_SIGN_IN } from 'pages/constants';

const Redirect = ({ to }) => {
    const location = useLocation();
    return <Navigate to={to} replace state={{ from: location }} />;
};

const PrivateRoute = (props) => {
    const { initialized, isSignedIn } = useAuth();
    const { path } = props;

    if (!initialized) {
        return (
            <Grid container justifyContent="center" alignItems="center" sx={{ width: '100%', height: '100vh' }}>
                <Grid item>
                    <LoaderSpinner type="Bars" color="#175da8" secondaryColor={'#6abed5'} height={70} width={70} />
                </Grid>
            </Grid>
        );
    }

    const isLoggedIn = !!isSignedIn;

    return isLoggedIn ? (
        <ErrorBoundary FallbackComponent={ErrorFallback} resetKeys={[path]}>
            {props.children}
        </ErrorBoundary>
    ) : (
        <Redirect to={ROUTE_SIGN_IN} />
    );
};

export default PrivateRoute;
